document.addEventListener("DOMContentLoaded", () => {
  function selectPackageCard(selectedCard) {
    const selectedPackageName = document.getElementById(
      "selected-package-name",
    );
    const currentPrice = document.getElementById("current-price");
    const comparePrice = document.getElementById("compare-price");
    const packageCards = document.querySelectorAll(".package-card");
    const saveAmount = document.getElementById("save-amount");

    packageCards.forEach((card) => {
      card.classList.remove("selected");
    });

    selectedCard.classList.add("selected");
    const data = selectedCard.dataset;
    const galleryThumb = document.querySelector(
      "#productGalleryThumbs .swiper-wrapper > div.swiper-slide > img",
    );
    const galleryMain = document.querySelector(
      ".product-gallery-custom-main .swiper-wrapper > div.swiper-slide > img",
    );
    if (galleryThumb) {
      galleryThumb.src = `${data.image}&crop=center&height=100&width=100`;
    }
    if (galleryMain) {
      galleryMain.src = data.image;
    }

    selectedPackageName.textContent = `Selected: ${data.packageName}`;
    currentPrice.textContent = `$${data.price} USD`;
    comparePrice.textContent = `$${data.comparePrice} USD`;
    saveAmount.textContent = `Save $${data.save}`;
  }

  document.querySelector(".package-grid")?.addEventListener("click", (event) => {
    const clickedCard = event.target.closest(".package-card");

    if (!clickedCard) return;

    selectPackageCard(clickedCard);

    // Keep the selection in the URL so it survives reloads and can be shared
    const url = new URL(window.location.href);
    if (clickedCard.dataset.giftItems && url.searchParams.get("pack") !== clickedCard.dataset.giftItems) {
      url.searchParams.set("pack", clickedCard.dataset.giftItems);
      window.history.replaceState(window.history.state, "", url);
    }
  });

  // Preselect a package from the URL, e.g. ?pack=42559817973925 (the card's data-gift-items value)
  const packFromUrl = new URLSearchParams(window.location.search).get("pack");
  if (packFromUrl) {
    const packCard = document.querySelector(
      `.package-selector .product-pack[data-gift-items="${CSS.escape(packFromUrl)}"]`,
    );

    if (packCard) {
      selectPackageCard(packCard);
    }
  }

  async function addToCartExclusive(cartItems)
  {
    const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
    const cartData = await cartResponse.json();
    const products = cartData.items;
    const GIFT_CONFIG = {
      42559852511397: {
        productQuantity: 3,
        productId: 52275164217712,
        giftQuantity: 1,
        order: 2,
        discount: "WELL-3",
      },
      42559817973925: {
        productQuantity: 2,
        productId: 52275164217712,
        giftQuantity: 1,
        order: 1,
        discount: "WELL-2",
      },
      42518432153765: {
        productQuantity: 1,
        productId: 52275164217712,
        giftQuantity: 1,
        order: 0,
        discount: "WELL",
      },
    };

    const chooseProduct = GIFT_CONFIG[cartItems];
    const eligibleProductsGift = products.reduce((acc, product) => {
      const hasDiscount = product.discounts.some(
        (d) => d.title === GIFT_CONFIG[product.variant_id]?.discount,
      );
      if (hasDiscount) {
        acc.push({ key: product.key, ...GIFT_CONFIG[product.variant_id] });
      }
      return acc;
    }, []);
    const cartUpdates = {};
    if (!eligibleProductsGift.length) {
      cartUpdates[chooseProduct.productId] = chooseProduct.productQuantity;
      cartUpdates[cartItems] = chooseProduct.giftQuantity;
    } else {
      cartUpdates[eligibleProductsGift[0].key] = 0;
      const eligibleProduct = products.reduce((acc, product) => {
        const hasDiscount = product.discounts.some(
          (d) => d.title === eligibleProductsGift[0]?.discount,
        );
        if (
          hasDiscount &&
          eligibleProductsGift[0].productId === product.variant_id
        ) {
          acc.push({ key: product.key });
        }
        return acc;
      }, []);
      cartUpdates[eligibleProduct[0].key] = chooseProduct.productQuantity;
      cartUpdates[cartItems] = chooseProduct.giftQuantity;
    }
    const updateResponse = await fetch(
      `${Shopify.routes.root}cart/update.js`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          updates: cartUpdates,
          sections: `${document
            .querySelector("cart-drawer")
            .closest(".shopify-section")
            .id.replace("shopify-section-", "")}`,
        }),
      },
    );
    const cartContent = await updateResponse.json();
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          cart: cartContent,
        },
      }),
    );
    document.querySelector("cart-drawer").show();
  }
  
  document.querySelector(".package-selector #add-to-cart-button")?.addEventListener("click", async (e) => {
    e.preventDefault();
    const selected = document.querySelector(
      ".package-selector .product-pack.selected",
    );

    if (!selected) {
      return;
    }
    const cartItems = selected.dataset?.giftItems || null;

    if (!cartItems) {
      return;
    }
    
    await addToCartExclusive(cartItems);
  });

  window.checkDiscount = async ({ products, discounts, quantity }) => {
    const GIFT_CONFIG = {
      42559852511397: {
        productQuantity: 3,
        productId: 52275164217712,
        giftQuantity: 1,
        order: 2,
        discount: "WELL-3",
      },
      42559817973925: {
        productQuantity: 2,
        productId: 52275164217712,
        giftQuantity: 1,
        order: 1,
        discount: "WELL-2",
      },
      42518432153765: {
        productQuantity: 1,
        productId: 52275164217712,
        giftQuantity: 1,
        order: 0,
        discount: "WELL",
      },
    };
    const eligibleProductsGift = products.reduce((acc, product) => {
      if (discounts.includes(GIFT_CONFIG[product.variant_id]?.discount)) {
        acc.push({ key: product.key, ...GIFT_CONFIG[product.variant_id] });
      }
      return acc;
    }, []);
    const cartUpdates = {};
    if (eligibleProductsGift.length) {
      cartUpdates[eligibleProductsGift[0].key] = 0;
      const [key, value] = Object.entries(GIFT_CONFIG).find(
        ([key, item]) => item.productQuantity === quantity,
      );
      cartUpdates[key] = value.giftQuantity;
      const updateResponse = await fetch(
        `${Shopify.routes.root}cart/update.js`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            updates: cartUpdates,
            sections: `${document
              .querySelector("cart-drawer")
              .closest(".shopify-section")
              .id.replace("shopify-section-", "")}`,
          }),
        },
      );
      const cartContent = await updateResponse.json();
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            cart: cartContent,
          },
        }),
      );
      document.querySelector("cart-drawer").show();
    }
  };

  document.getElementById("exclusive_offer")?.addEventListener("click", async (e) => {
    e.preventDefault();
    const cartItems = e.currentTarget.dataset?.giftItems || null;

    if (!cartItems) {
      return;
    }
    
    await addToCartExclusive(cartItems);
  });
});
